<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card v-if="!computeCampagne">
          <div class="row align--center">
            <div class="flex xs6 md3">
              <va-input :value="nomRe" :placeholder="$t('poissonnierTable.searchByName')" removable @input="searchNom">
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>

            <div class="flex xs6 md3">
              <va-input :value="cpRe" :placeholder="$t('poissonnierTable.searchByPostcode')" removable
                @input="searchPostcode">
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>
            <div class="flex xs12 md3">
              <div class="row row-inside">
                <va-button-toggle v-show="filter !== 'getAll'" outline class="toggle-activite" v-model="showinactive"
                  :options="options" />
                <h5 class="selection-nb-title" :style="{ color: this.$themes.primary }">
                  Sélect. : {{ filteredData.length }}
                </h5>
                <va-popover message="Rafraichir" placement="top">
                  <va-button class="selection-refresh" flat color="primary" icon="fa fa-refresh" @click="loadList()" />
                </va-popover>
              </div>
            </div>
            <div class="flex md2">
              <va-button v-show="filter !== 'getAll' || syndicat !== 'unpf'" class="offset-top" outline
                :color="selectGrossiste ? 'info' : 'primary'" @click="selectGrossiste = !selectGrossiste">{{
                  selectGrossiste ? "Autres entreprises" : "Grossistes"
                }}</va-button>
            </div>

            <div class="flex xs6 md1">
              <va-input class="centered" :value="perPage" :label="$t('tables.perPage')"
                @input="changePageNumber"></va-input>
            </div>
          </div>
          <div v-if="loadingStatuts" class="d-flex justify--center spinner">
            <div>
              <va-progress-circle indeterminate />
            </div>
          </div>

          <va-data-table ref="dataTableSyndicat" class="va-table--hoverable va-table--stripped no-overflow"
            :fields="fields" :data="filteredData" :no-data-label="$t('poissonnierTable.empty')"
            :per-page="parseInt(perPage)" @row-clicked="showEntreprise" clickable page="3">
            <template slot="fin_adhesion_adt" slot-scope="props">
              <div class="row row-inside"">
                  <div class=" flex md12">
                <p class="last-send" v-if="props.rowData.mdate_fin">
                  {{ props.rowData.mdate_fin }}
                </p>
                <va-badge v-if="props.rowData.df_aad" v-for="item in props.rowData.adhesionsTierces" color="danger"
                  class="fullwidth">{{ item }}</va-badge>
              </div>
      </div>
      </template>

      <template slot="level" slot-scope="props">
        <div class="row row-inside" @click="changeLevel(props.rowData)">
          <div class="flex md12">
            <va-badge v-if="props.rowData.max_level === 1" color="success" class="fullwidth">Niveau 1</va-badge>
            <va-badge v-if="props.rowData.max_level === 2" color="warning" class="fullwidth">Niveau 2</va-badge>
            <va-badge v-if="props.rowData.max_level === 3" color="danger" class="fullwidth">Niveau 3</va-badge>
            <p class="last-send" v-if="props.rowData.latest_env">
              {{ props.rowData.latest_env }}
            </p>
          </div>
        </div>
      </template>

      <template slot="comments" slot-scope="props">
        <div class="row row-inside comment-div" @click="preventDefaultAction">
          <div v-show="!props.rowData.showInput" class="flex md12" @click="displayCommentMod(props.rowData)">
            {{ props.rowData.comment }}
          </div>
          <div v-show="props.rowData.showInput" class="flex md12">
            <div class="row row-inside">
              <div class="flex md11">
                <va-input v-model="props.rowData.comment" type="textarea" autosize />
              </div>
              <div class="flex md1">
                <va-button flat color="primary" icon="fa fa-close" @click="closeComment(props.rowData)" />
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="selection" slot-scope="props">
        <div v-if="props.rowData.max_level < 3 &&
          isRelancable(props.rowData.latest_env) &&
          (!selectLimit || props.rowData.selected)
          " class="row row-inside" @click="preventDefaultAction">
          <div class="flex md3">
            <va-checkbox v-model="props.rowData.selected" :disabled="!!props.rowData.nocourrier && props.rowData.emailDisabled
              " />
          </div>
          <div class="flex md9" v-show="props.rowData.selected">
            <div class="row row-inside">
              <va-checkbox v-model="props.rowData.sendemail" label="email" :disabled="props.rowData.emailDisabled" />
              <va-checkbox v-model="props.rowData.sendcourrier" label="courrier" :disabled="!!props.rowData.nocourrier" />
            </div>
          </div>
        </div>
        <div v-if="props.rowData.max_level === 3" class="row row-inside" @click="preventDefaultAction">
          <div class="flex md12">
            <va-badge color="danger">Nombre maximum de relance</va-badge>
          </div>
        </div>
        <div v-if="props.rowData.max_level < 3 &&
          !isRelancable(props.rowData.latest_env)
          " class="row row-inside" @click="preventDefaultAction">
          <div class="flex md12">
            <va-badge color="warning" class="fullwidth">Attendre
              {{ nbJoursRelance(props.rowData.latest_env) }}
              jours</va-badge>
          </div>
        </div>
      </template>
      <template slot="attributed" slot-scope="props">
        <div class="row row-inside">
          <div class="flex md12">
            <va-popover placement="left " color="info" :message="attributionMessage(props.rowData)">
              <va-button flat large :color="attributionColor(props.rowData)" icon="fa fa-circle"
                @click="changeAttribution(props.rowData)" />
            </va-popover>
          </div>
        </div>
      </template>
      <template slot="actions" slot-scope="props">
        <div class="row row-inside" @click="preventDefaultAction">
          <div class="flex md3">
            <va-popover placement="right" color="info" message="Changer le contact pour la campagne d'adhésion">
              <va-button v-if="props.rowData.nbcontacts > 1" flat large color="info" icon="fa fa-address-book"
                @click="changeCampaignContact(props.rowData)" />
            </va-popover>
          </div>
          <div class="flex md3">
            <va-popover placement="right" color="info" message="Personnaliser l'envoi">
              <va-button flat large :color="props.rowData.customText ||
                  (props.rowData.customEmail &&
                    props.rowData.customEmail.body)
                  ? 'primary'
                  : 'info'
                " icon="fa fa-edit" @click="customize(props.rowData)" />
            </va-popover>
          </div>
          <div class="flex md2">
            <va-popover placement="right" color="info" message="Retirer du plan d'adhésion">
              <va-button flat large color="info" icon="fa fa-close" @click="removeFromPlan(props.rowData)" />
            </va-popover>
          </div>
        </div>
      </template>
      </va-data-table>
      <div class="flex xs12 md1 offset--md11">
        <div class="row row-inside">
          <va-button large class="start-button" @click="validateAndStart" :disabled="!selected.length">Valider</va-button>
        </div>
      </div>
      </va-card>
    </div>
  </div>
  <dashboard-fiche-entreprise v-model="showFicheEntreprise" :tableentreprise="tableentreprise"
    @update="updateEntreprise" />
  <va-modal class="modal" title="Validation du plan d'adhésion" v-model="showConfirm" cancelClass="clearStats"
    okText="Valider" cancelText="Annuler" max-width="100%" v-on:ok="launchCampaign()" v-on:cancel="clearStats">
    <div class="forcewidth-campagne">
      <div class="row row-inside">
        <div class="flex md6">
          <div class="row row-inside">
            <div class="flex md12">
              <h4 v-if="filter === 'getAll'" :style="{ color: this.$themes.primary }">
                Envois
              </h4>
              <h4 v-else :style="{ color: this.$themes.primary }">
                Adhérents
              </h4>
            </div>
            <div class="flex md3 mt-2 mb-1">
              <va-badge color="success" class="fullwidth">Niveau 1</va-badge>
            </div>
            <div class="flex md12 mb-2">
              <p :style="{ color: this.$themes.primary }">
                Envoi de
                <b class="black-text">{{ n1AdhMail }}</b>
                courriels / Impression de
                <b class="black-text">{{ n1AdhCour }}</b>
                courriers
              </p>
            </div>
            <div class="flex md3 mt-2 mb-1">
              <va-badge color="warning" class="fullwidth">Niveau 2</va-badge>
            </div>
            <div class="flex md12 mb-2">
              <p :style="{ color: this.$themes.primary }">
                Envoi de
                <b class="black-text">{{ n2AdhMail }}</b>
                courriels / Impression de
                <b class="black-text">{{ n2AdhCour }}</b>
                courriers
              </p>
            </div>
            <div class="flex md3 mt-2 mb-1">
              <va-badge color="danger" class="fullwidth">Niveau 3</va-badge>
            </div>
            <div class="flex md12">
              <p :style="{ color: this.$themes.primary }">
                Envoi de
                <b class="black-text">{{ n3AdhMail }}</b>
                courriels / Impression de
                <b class="black-text">{{ n3AdhCour }}</b>
                courriers
              </p>
            </div>
          </div>
        </div>
        <div v-if="filter !== 'getAll'" class="flex md6">
          <div class="row row-inside">
            <div class="flex md12">
              <h4 :style="{ color: this.$themes.primary }">
                Adhésions expirées
              </h4>
            </div>
            <div class="flex md3 mt-2 mb-1">
              <va-badge color="success" class="fullwidth">Niveau 1</va-badge>
            </div>
            <div class="flex md12 mb-2">
              <p :style="{ color: this.$themes.primary }">
                Envoi de
                <b class="black-text">{{ n1NAdhMail }}</b>
                courriels / Impression de
                <b class="black-text">{{ n1NAdhCour }}</b>
                courriers
              </p>
            </div>
            <div class="flex md3 mt-2 mb-1">
              <va-badge color="warning" class="fullwidth">Niveau 2</va-badge>
            </div>
            <div class="flex md12 mb-2">
              <p :style="{ color: this.$themes.primary }">
                Envoi de
                <b class="black-text">{{ n2NAdhMail }}</b>
                courriels / Impression de
                <b class="black-text">{{ n2NAdhCour }}</b>
                courriers
              </p>
            </div>
            <div class="flex md3 mt-2 mb-1">
              <va-badge color="danger" class="fullwidth">Niveau 3</va-badge>
            </div>
            <div class="flex md12">
              <p :style="{ color: this.$themes.primary }">
                Envoi de
                <b class="black-text">{{ n3NAdhMail }}</b>
                courriels / Impression de
                <b class="black-text">{{ n3NAdhCour }}</b>
                courriers
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </va-modal>
  <va-card v-if="computeCampagne && !displayError">
    <h4>Génération du document en cours, veuillez patienter</h4>
    <br />
    <va-progress-bar :value="valueProgress" />
  </va-card>
  <va-card v-if="displayError">
    <br />
    <br />
    <h4>
      Une erreur semble avoir survenue lors du document. Veuillez patienter
      15min, rafraichir la page et regarder dans l'onglet archive si les
      envois ont été générés.
    </h4>
    <br />
    <br />
  </va-card>
  <va-modal class="modal" title="Choix du contact pour la campagne d'adhésion" v-model="showContacts" okText="Valider"
    cancelText="Annuler" max-width="100%" v-on:ok="changeContact()" v-on:cancel="clearStats">
    <div class="row row-inside">
      <div class="flex md12" v-for="contact in listContacts" v-bind:class="{
        'primary-contact': contact.idcontact === primaryContactId,
      }">
        <va-radio-button :option="contact.idcontact" v-model="contactSelectedOption" :label="contact.titre +
          ' ' +
          contact.nom +
          ' ' +
          contact.prenom +
          (contact.fonction ? ' | ' + contact.fonction : '')
          " />
      </div>
      <div class="flex md12">
        <va-radio-button :option="'reset'" v-model="contactSelectedOption" label="Contact par défault" />
      </div>
    </div>
  </va-modal>
  <remove-from-campaign v-model="showCampaignRemove" :identreprise="selectedEntreprise"
    :nomEntreprise="selectedEntrepriseName" v-on:reset="removeEntreprise" />
  <dashboard-custom-campaign v-model="showCustomCampaign" :identreprise="selectedEntreprise"
    :entreprise="selectedEntrepriseInfos" @update="updateCustom" />
  <change-level :syndicat="syndicat" :identreprise="changeLevelId" @cancel="changeLevelId = null"
    @update="updateAfterLevelChange"></change-level>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, debounce, findIndex, deburr } from "lodash";
import DashboardFicheEntreprise from "../dashboard/DashboardFicheEntreprise";
import RemoveFromCampaign from "../campaigns/RemoveFromCampaign";
import DashboardCustomCampaign from "./DashboardCustomCampaign";
import ChangeLevel from "./ChangeLevel";

import { mapGetters } from "vuex";
import moment from "moment";
import { launchToast } from "../../services/utils";

export default {
  components: {
    RemoveFromCampaign,
    DashboardFicheEntreprise,
    DashboardCustomCampaign,
    ChangeLevel,
  },
  props: ["syndicat", "filter"],
  data() {
    return {
      changeLevelId: null,
      selectedEntrepriseName: null,
      selectedEntreprise: null,
      showCampaignRemove: false,
      selectGrossiste: false,
      computeCampagne: false,
      valueProgress: 0,
      showWorkOnProgress: false,
      n1AdhMail: 0,
      n2AdhMail: 0,
      n3AdhMail: 0,
      n1NAdhMail: 0,
      n2NAdhMail: 0,
      n3NAdhMail: 0,
      n1AdhCour: 0,
      n2AdhCour: 0,
      n3AdhCour: 0,
      n1NAdhCour: 0,
      n2NAdhCour: 0,
      n3NAdhCour: 0,
      showConfirm: false,
      loadingStatuts: true,
      deleteModalMessage: "Supprimer l'entreprise?",
      options: [
        { label: "Adh.", value: "adherent" },
        { label: "Exp.", value: "expired" },
        { label: "Tous", value: "all" },
      ],
      showinactive: "all",
      tableentreprise: "",
      show: true,
      showFicheEntreprise: false,
      isaction: false,
      nomRe: null,
      cpRe: null,
      villeRe: null,
      dataEntreprises: [],
      perPage: "6",
      entrepriseName: null,
      showContacts: false,
      listContacts: [],
      contactSelectedOption: null,
      primaryContactId: null,
      displayError: false,
      selectCustomEmail: null,
      selectedCustomText: null,
      showCustomCampaign: false,
      selectedEntrepriseInfos: null,
    };
  },
  computed: {
    ...mapGetters(["loadEntreprise"]),
    selected() {
      return this.dataEntreprises.filter((item) => {
        return item.selected;
      });
    },
    selectLimit() {
      if (this.selected.length > 29) return true;
      return false;
    },
    fields() {
      return [
        {
          name: "nom",
          title: this.$t("poissonnierTable.headings.enseigne"),
          sortField: "nom",
          width: "12%",
        },
        {
          name: "code_postal",
          title: "Code Postal",
          sortField: "code_postal",
          width: "5%",
          dataClass: "adresse-smalltext",
        },
        {
          name: "ville",
          title: "Ville",
          sortField: "ville",
          width: "8%",
          dataClass: "adresse-smalltext",
        },
        {
          name: "contact_name",
          title: "Dirigeant",
          sortField: "contact_name",
          width: "8%",
          dataClass: "adresse-smalltext",
        },
        {
          name: "__slot:fin_adhesion_adt",
          title: "Fin d'adhésion",
          sortField: "mdate_fin",
          width: "8%",
        },
        {
          name: "__slot:level",
          title: "Niveau de relance",
          sortField: "max_levelTxt",
          width: "8%",
        },
        {
          name: "__slot:comments",
          title: "Commentaire",
          width: "15%",
        },

        {
          name: "__slot:selection",
          title: "Sélection",
          dataClass: "text-right",
          width: "8%",
        },
        {
          name: "__slot:attributed",
          title: "Attribué",
          dataClass: "text-right",
          width: "4%",
        },

        {
          name: "__slot:actions",
          title: "Personnalisation",
          width: "13%",
        },
      ];
    },

    filteredData() {
      let filteredData = this.dataEntreprises;
      if (this.filter === "getAll") {
        this.showinactive = "all";
        if (this.syndicat === "unpf") {
          this.selectGrossiste = false;
        }
      }

      // if (
      //   (!this.nomRe || this.nomRe.length < 1) &&
      //   (!this.cpRe || this.cpRe.length < 1) &&
      //   this.showinactive === "all"
      // ) {
      //   return filteredData;
      // }

      return filteredData.filter((item) => {
        let boolcond = true;

        if (this.selectGrossiste) {
          boolcond = item.ent_APE === "4638A";
        } else {
          boolcond = item.ent_APE !== "4638A";
        }

        let momentDF = moment(item.mdate_fin, "DD-MM-YYYY");
        if (this.showinactive === "adherent" && momentDF.isBefore(moment())) {
          boolcond = false;
        }
        if (this.showinactive === "expired" && !momentDF.isBefore(moment())) {
          boolcond = false;
        }

        if (this.nomRe && this.nomRe.length >= 1) {
          let nomCpre = deburr(this.nomRe).toLowerCase();
          boolcond =
            boolcond &&
            (deburr(item.nom).toLowerCase().includes(nomCpre) ||
              deburr(item.contact_name).toLowerCase().includes(nomCpre));
        }

        if (this.cpRe && this.cpRe.length >= 1) {
          let cpCpre = deburr(this.cpRe).toLowerCase();
          boolcond =
            boolcond &&
            (deburr(item.code_postal).toLowerCase().includes(cpCpre) ||
              deburr(item.ville).toLowerCase().includes(cpCpre));
        }

        return boolcond;
      });
    },
  },
  mounted() {
    this.loadList();
  },
  methods: {
    async changeAttribution(infos) {
      this.preventDefaultAction();
      try {
        //send request for attribution
        let res = await axios.put("/api/campagne/assign", {
          identreprise: infos.identreprise,
        });
        console.log(res.data);
        if (res.data === "locked") {
          this.launchEpicmaxToast("Entreprise attribuée");

          this.updateEntreprise(infos.identreprise);
        } else if (res.data === "released") {
          this.launchEpicmaxToast("Entreprise désattribuée");
          this.updateEntreprise(infos.identreprise);
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.launchEpicmaxToast("Entreprise déjà attribuée");
        }

        console.log(error);
      }
      console.log(infos);
    },
    attributionColor(infos) {
      if (!infos.idutilisateurs) {
        return "info";
      }
      if (infos.idutilisateurs === this.$store.getters.user.idutilisateurs) {
        return "success";
      }
      return "danger";
    },
    attributionMessage(infos) {
      if (!infos.idutilisateurs) {
        return "Non attribué";
      }

      return infos.nom_complet;
    },
    async updateAfterLevelChange(identreprise) {
      console.log("identreprise", identreprise);
      this.updateEntreprise(identreprise);
      this.changeLevelId = null;
    },
    changeLevel(dataEntreprises) {
      this.preventDefaultAction();
      console.log("test");

      this.changeLevelId = dataEntreprises.identreprise;
    },
    updateCustom(payload) {
      let index = findIndex(this.dataEntreprises, {
        identreprise: payload.identreprise,
      });
      console.log("custom", payload);
      this.dataEntreprises[index].customText = payload.courrier;
      this.dataEntreprises[index].courrierSubject = payload.courrierSubject;
      this.dataEntreprises[index].customEmail = payload.email;
    },
    removeEntreprise(payload) {
      if (payload[this.syndicat]) {
        let index = findIndex(this.dataEntreprises, {
          identreprise: payload.identreprise,
        });

        if (index !== -1) {
          this.dataEntreprises.splice(index, 1);
        }
      }
    },
    removeFromPlan(entreprise) {
      this.selectedEntrepriseName = entreprise.nom;
      this.selectedEntreprise = entreprise.identreprise;

      this.showCampaignRemove = true;
    },
    isRelancable(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD").add(2, "weeks").isBefore(moment());
      } else {
        return true;
      }
    },
    nbJoursRelance(date) {
      let dateM = moment(date, "YYYY-MM-DD").add(2, "weeks");
      let today = moment();
      return dateM.diff(today, "days");
    },
    clearStats() {
      this.n1AdhMail = 0;
      this.n2AdhMail = 0;
      this.n3AdhMail = 0;
      this.n1NAdhMail = 0;
      this.n2NAdhMail = 0;
      this.n3NAdhMail = 0;
      this.n1AdhCour = 0;
      this.n2AdhCour = 0;
      this.n3AdhCour = 0;
      this.n1NAdhCour = 0;
      this.n2NAdhCour = 0;
      this.n3NAdhCour = 0;
    },
    async changeCampaignContact(rowData) {
      // get the contact list, the current main campagne contact and the primary contact of the siege
      // The primary contact is displayed in green in the list
      let res = await axios.get("/api/campagne/contacts", {
        params: { identreprise: rowData.identreprise },
      });
      this.listContacts = res.data.contactList;
      this.contactSelectedOption = res.data.idcontactCampagne;
      this.primaryContactId = res.data.etablissementContact;
      this.showContacts = true;
    },
    async changeContact() {
      this.showContacts = true;
      //TODO robustify
      let params = {
        identreprise: this.listContacts[0].entreprise_identreprise,
        idcontact: this.contactSelectedOption,
      };
      await axios.put("/api/campagne/contact", params);
      this.showContacts = false;
    },
    customize(entreprise) {
      this.selectedEntrepriseName = entreprise.nom;
      this.selectedEntreprise = entreprise.identreprise;
      this.selectedEntrepriseInfos = entreprise;

      this.showCustomCampaign = true;
    },
    async launchCampaign() {
      try {
        this.valueProgress = 0;
        this.computeCampagne = true;
        let params = {
          campaignType: this.filter,
          syndicat: this.syndicat,
          selected: this.selected,
          grossiste: this.selectGrossiste,
        };
        this.computeCampagne = true;
        this.updateProgress();
        let pres = axios.post("/api/campagne/launch-campaign", params);
        //force deselection
        this.clearStats();
        this.dataEntreprises = [];
        let res = await pres;
        let url = res.data.pdfUrl;
        let errorEmail = res.data.emailError;
        if (errorEmail === 0) {
          this.launchEpicmaxToast("Courriels envoyés");
        } else {
          this.launchEpicmaxToast(
            "Courriels non envoyés: " +
            errorEmail +
            " vérifier dans l’onglet archives"
          );
        }

        if (url !== "no pdf") {
          window.open(url, "_blank");
          this.downloadItem(url, "Bulletins " + this.syndicat);
        }
        this.loadList();
        this.computeCampagne = false;
        this.valueProgress = 0;
      } catch (err) {
        console.log(err);
        this.loadList();
        this.clearStats();
        this.displayError = true;
      }
    },
    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    async updateProgress() {
      setInterval(() => {
        this.valueProgress += 1;
      }, 400);
    },
    updateChoice(row) {
      row.sendcourrier = true;
      row.sendemail = true;
    },
    async closeComment(rowData) {
      this.preventDefaultAction();

      // save comment if change
      if (rowData.comment !== rowData.commentSave) {
        let params = {
          identreprise: rowData.identreprise,
          comment: rowData.comment,
          syndicat: this.syndicat,
        };
        await axios.put("/api/campagne/save-comment", params);
        rowData.showInput = false;
      } else {
        rowData.showInput = false;
      }
    },
    displayCommentMod(rowData) {
      this.preventDefaultAction();
      rowData.commentSave = rowData.comment;
      rowData.showInput = true;
    },
    preventDefaultAction() {
      this.isaction = true;
    },
    validateAndStart() {
      // calculate stats:
      this.selected.forEach((element) => {
        // is adherent or expired

        if (
          moment(element.mdate_fin, "DD-MM-YYYY").isSameOrAfter(moment()) ||
          this.filter === "getAll"
        ) {
          if (element.max_level === 2) {
            if (element.sendcourrier) this.n3AdhCour += 1;
            if (element.sendemail) this.n3AdhMail += 1;
          } else if (element.max_level === 1) {
            if (element.sendcourrier) this.n2AdhCour += 1;
            if (element.sendemail) this.n2AdhMail += 1;
          } else {
            if (element.sendcourrier) this.n1AdhCour += 1;
            if (element.sendemail) this.n1AdhMail += 1;
          }
        } else {
          if (element.max_level === 2) {
            if (element.sendcourrier) this.n3NAdhCour += 1;
            if (element.sendemail) this.n3NAdhMail += 1;
          } else if (element.max_level === 1) {
            if (element.sendcourrier) this.n2NAdhCour += 1;
            if (element.sendemail) this.n2NAdhMail += 1;
          } else {
            if (element.sendcourrier) this.n1NAdhCour += 1;
            if (element.sendemail) this.n1NAdhMail += 1;
          }
        }
      });

      this.showConfirm = true;
    },
    updateValue(value) {
      value.max_levelTxt = value.max_level ? value.max_level.toString() : "0";
      value.mdate_fin = value.mdate_fin
        ? moment(value.mdate_fin).format("DD-MM-YYYY")
        : "";
      value.selected = false;
      value.sendcourrier = true;
      value.showInput = false;

      //email for the firm exist
      if (value.email) {
        value.sendemail = true;
        value.emailDisabled = false;
      } else {
        value.sendemail = false;
        value.emailDisabled = true;
      }

      // nocourrier (retour)
      if (value.nocourrier) {
        value.sendcourrier = false;
      }
      // check email for the main contact
      if (
        (!value.set_contact_name && value.contact_main_email) ||
        (value.set_contact_name && value.set_contact_email)
      ) {
        value.sendemail = true;
        value.emailDisabled = false;
      }
      value.customText = "";
      value.customEmail = {
        body: null,
        courrielSubject: null,
        signatureType: false,
        signatureName: "Pierre-Luc DAUBIGNEY",
        signatureFonction: "Secrétaire général",
        signatureTelephone: "06 45 12 53 10",
      };
      return value;
    },
    async updateEntreprise(identreprise) {
      try {
        // TODO
        //highly inefficient... loading the whole list and filtering
        let resp = await axios.get("/api/prospectables", {
          params: { syndicat: this.syndicat, filter: this.filter },
        });

        // find index in response
        let tmpList = resp.data;

        let indexResp = findIndex(tmpList, {
          identreprise: identreprise,
        });

        let tmpValue = this.updateValue(tmpList[indexResp]);
        let oldIndex = findIndex(this.dataEntreprises, {
          identreprise: identreprise,
        });
        console.log(this.dataEntreprises[oldIndex]);

        tmpValue.selected = this.dataEntreprises[oldIndex].selected;
        tmpValue.sendcourrier = this.dataEntreprises[oldIndex].sendcourrier;
        tmpValue.sendemail = this.dataEntreprises[oldIndex].sendemail;
        tmpValue.customText = this.dataEntreprises[oldIndex].customText;
        tmpValue.customEmail = this.dataEntreprises[oldIndex].customEmail;
        tmpValue.courrierSubject =
          this.dataEntreprises[oldIndex].courrierSubject;

        this.dataEntreprises.splice(oldIndex, 1, tmpValue);
      } catch (err) {
        console.log(err);
      }
    },
    async loadList() {
      try {
        this.loadingStatuts = true;
        let resp = await axios.get("/api/prospectables", {
          params: { syndicat: this.syndicat, filter: this.filter },
        });

        for (let value of resp.data) {
          this.updateValue(value);
        }
        this.dataEntreprises = resp.data;
        this.loadingStatuts = false;
        this.showinactive = "all";
      } catch (err) {
        this.loadingStatuts = false;

        console.log(err);
      }
    },
    showEntreprise(entreprise) {
      if (!this.isaction) {
        this.showFicheEntreprise = true;
        this.tableentreprise = entreprise;
      }
      this.isaction = false;
    },
    searchNom: debounce(function (nomRe) {
      this.nomRe = nomRe;
    }, 400),
    changePageNumber: debounce(function (perPage) {
      var n = Math.floor(Number(perPage));
      if (n !== Infinity && String(n) === perPage && n >= 0) {
        this.perPage = perPage;
      } else {
        this.perPage = "6";
      }
    }, 400),
    searchPostcode: debounce(function (cpRe) {
      this.cpRe = cpRe;
    }, 400),
    switchPage: debounce(function (page) {
      this.$refs.dataTableSyndicat.currentPage = page;
      this.$refs.dataTableSyndicat.inputPage(page.toString());
    }, 400),
    async getDataEntreprise(identreprise) {
      try {
        let entreprise = await axios.get("/api/entreprises-syndicat", {
          params: { identreprise: identreprise, syndicat: this.syndicat },
        });
        return entreprise.data;
      } catch (error) {
        console.log(error);
      }
    },

    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  watch: {
    filter() {
      this.loadList();
    },
    loadEntreprise(newid) {
      if (newid) {
        let i = findIndex(this.dataEntreprises, ["identreprise", newid]);
        this.showEntreprise(this.dataEntreprises[i]);
        this.$store.commit("setLoadEntreprise", false);
      }
    },
  },
  events: {
    hideComment: function () {
      console.log("close event called");
    },
  },
};
</script>

<style lang="scss">
.centered input {
  text-align: center;
}

.create-button {
  position: relative;
}

.toggle-activite {
  position: relative;
  top: -0.5em;
}

.align-center {
  text-align: center;
}

.spinner {
  top: 50%;
  left: 50%;
}

.adresse-smalltext {
  font-size: 0.9em;
}

.selection-nb-title {
  position: relative;
  top: 0.4em;
}

.no-overflow {
  overflow: hidden;
}

.selection-refresh {
  position: relative;
  top: -0.3em;
}

.start-button {
  position: relative;
}

.forcewidth-campagne {
  width: 50vw;
  overflow: hidden;
}

.black-text {
  color: black;
}

.last-send {
  text-align: center;
}

.comment-div {
  width: 100%;
  min-height: 3em;
}

.primary-contact {
  color: #4ae387;
}
</style>
